import { push } from "connected-react-router";
import Action from "pages/_components/Action";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool } from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { actions as echeckActions } from "reducers/echecks";
import { echeckTabTitles, echeckTitles, echeqOptions } from "util/echecks";
import { isIOS } from "react-device-detect";
import EmitedEchecks from "./EmitedEchecks";
import ReceivedEchecks from "./ReceivedEchecks";

const EchecksPage = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const { state = { tab: 0 } } = useLocation();
    const echeckMainTitle = echeckTitles[state.tab];
    const { echeqFilters, echeqPagination: _echeqPagination } = useSelector((_state) => _state.echecks);
    const { fetchingEcheqList: fetching } = useSelector((_state) => _state.echecks);

    const handleDownload = () => {
        const { pageNumber, totalPages } = _echeqPagination;
        const option = echeqOptions[state.tab];
        const filtersEcheq = { ...echeqFilters, option, pageNumber, totalPages };
        dispatch(echeckActions.downloadEcheqList(filtersEcheq));
    };

    useEffect(() => {
        dispatch(echeckActions.cleanEcheqAction());
    }, [dispatch]);

    const tabsData = [
        {
            text: echeckTabTitles[0],
            textType: "I18N",
        },
        {
            text: echeckTabTitles[1],
            textType: "I18N",
        },
    ];

    const fetchMoreTransactions = (echeqPagination, filters, setSelectedAll = null) => {
        if (setSelectedAll) {
            setSelectedAll(false);
        }
        const filtersEcheq = {
            ...filters,
            pageNumber: echeqPagination.pageNumber + 1,
        };
        dispatch(echeckActions.filterEcheqList(filtersEcheq));
    };

    return (
        <>
            <Notification scopeToShow="echecks" />
            <Notification scopeToShow="echecksMainPage" />
            <ResponsiveHeader id={echeckMainTitle} backLinkTo="/desktop">
                <DesktopButtons>
                    <CustomButton
                        className="btn-outline"
                        func={() => handleDownload()}
                        icon="images/figma/icon/download.svg"
                        text="global.download"
                        textType="I18N"
                        loading={fetching}
                    />
                    <CustomButton
                        func={() => dispatch(push("/echecks/emit"))}
                        className="btn btn-primary btn-block"
                        icon="images/figma/icon/nuevo.svg"
                        text="echecks.new"
                        textType="I18N"
                    />
                    <CustomButton
                        func={() => dispatch(push("/massiveEchecks"))}
                        className="btn btn-primary btn-block"
                        icon="images/figma/icon/nuevo.svg"
                        text="massive.echeck.button"
                        textType="I18N"
                    />
                </DesktopButtons>
                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action labelKey="echecks.new" to="/echecks/emit" />
                    <Action labelKey="massive.echeck.button" to="/massiveEchecks" />
                    <Action labelKey="global.download.xls" handleClick={() => handleDownload()} />
                </MobileButtons>
            </ResponsiveHeader>
            <MainContainer>
                <CustomTabs tabsData={tabsData}>
                    <ReceivedEchecks isDesktop={isDesktop} fetchMoreTransactions={fetchMoreTransactions} />
                    <EmitedEchecks isDesktop={isDesktop} fetchMoreTransactions={fetchMoreTransactions} />
                </CustomTabs>
            </MainContainer>
        </>
    );
};

EchecksPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default EchecksPage;
